module.exports = __webpack_public_path__ + "img/My chat active.cffe1036.svg";